<template>
  <div>
    <div class="section1" :style="'background-image: url(' + $env.imgUrl + 'pbl-s1-bg.png);'">
      <div class="safe-area">
        <div class="imgs">
          <img :src="$env.imgUrl + 'pbl-s1-1.png'" alt="">
          <img :src="$env.imgUrl + 'pbl-s1-2.png'" alt="">
          <img :src="$env.imgUrl + 'pbl-s1-3.png'" alt="">
          <img :src="$env.imgUrl + 'pbl-s1-4.png'" alt="">
        </div>
        <div class="common-title-d3">以联合国教科文组织“文化多样性保护、全球公民素养培育”理念为指引，结合本土文化资源与PBL实施规范，设立四大核心探究主题，构建多元赛道矩阵，适配不同兴趣、不同方向的青少年探究需求。</div>
        <div class="common-title-d4 mt-12">Cultivate young people who possess both cultural confidence in their national heritage and a global perspective, and establish a multi-layered identity recognition: community participants, inheritors of Chinese culture, representatives of Chinese youth, global citizens, and guardians of nature, using the power of youth to promote the construction of a community with a shared future for mankind.</div>
      </div>
    </div>
    <div class="section2 safe-area page-flex-lr-center">
      <div class="lf">
        <pageTitle cn="非遗人文领域" en="ICH & Humanities Literacy" type="1"></pageTitle>
        <div class="common-title-d1">走入真实世界，以项目式学习的方式对话非遗匠人、复原传统技艺、创生文化表达。用PBL的方式去发现、去传承、去创造。</div>
        <div class="common-title-d2 mt-12">Step into the real world and, through project-based learning, engage with intangible cultural heritage artisans, revive traditional crafts, and create new forms of cultural expression. Use PBL to discover, preserve, and create.</div>
      </div>
      <div class="rt">
        <img :src="$env.imgUrl + 'pbl-s2-1.png?v=0720'" alt="">
        <img :src="$env.imgUrl + 'pbl-s2-2.png?v=0720'" alt="">
        <img :src="$env.imgUrl + 'pbl-s2-3.png?v=0720'" alt="">
        <img :src="$env.imgUrl + 'pbl-s2-4.png?v=0720'" alt="">
      </div>
    </div>
    <div class="section3" :style="'background-image: url(' + $env.imgUrl + 'pbl-bg-1.png);'">
      <div class="safe-area">
        <pageTitle cn="海洋科学领域" en="Marine Science Literacy" type="2"></pageTitle>
        <div class="common-title-d3 mt-20">本领域响应联合国“海洋科学促进可持续发展十年”号召，采用【作品征集制】，立足本土近海真实生态场景，融合自然观察、科学实验、公益科创、美育传播多元维度，引导青少年对标国际海洋生态治理理念，开展轻量化、实操性探究创作，助力培育学生科学探究能力、生态保护意识与全球责任素养。</div>
        <div class="common-title-d4 mt-12">In response to the United Nations’ call for the “Decade of Ocean Science for Sustainable Development,” this initiative is widely soliciting submissions from across the country. Rooted in real-world ecological scenarios in local coastal waters and integrating multiple dimensions—including nature observation, scientific experimentation, public-interest innovation, and aesthetic education—the initiative guides young people to align with international concepts of marine ecological governance. It encourages them to engage in accessible, hands-on exploratory projects, thereby helping to cultivate students’ scientific inquiry skills, ecological conservation awareness, and a sense of global responsibility.</div>
        <div class="page-flex-lr-top">
          <div class="vertical-title">
            <div>今年的海洋科学素养赛道</div>
            <div>的六大方向</div>
          </div>
          <div class="imgs">
            <img :src="$env.imgUrl + 'pbl-s3-1.png'" alt="">
            <img :src="$env.imgUrl + 'pbl-s3-2.png'" alt="">
            <img :src="$env.imgUrl + 'pbl-s3-3.png'" alt="">
            <img :src="$env.imgUrl + 'pbl-s3-4.png'" alt="">
            <img :src="$env.imgUrl + 'pbl-s3-5.png'" alt="">
            <img :src="$env.imgUrl + 'pbl-s3-6.png'" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="section4 safe-area page-flex-lr-center">
      <div class="lf">
        <pageTitle cn="AI科创领域" en="AI & Innovation Literacy " type="1"></pageTitle>
        <div class="common-title-d1 mt-20">大赛以PBL形式响应这一号召，让学生在项目实践中接触前沿科技，激发兴趣，为未来储备具有创新思维和实践能力的后备人才。</div>
        <div class="common-title-d2 mt-12">The competition responds to this call in the form of PBL, allowing students to engage with cutting-edge technology through project practice, stimulating their interest, and preparing future talents with innovative thinking and practical abilities.</div>
      </div>
      <div class="rt">
        <img :src="$env.imgUrl + 'pbl-s4.png'" alt="">
      </div>
    </div>
    <div class="section5" :style="'background-image: url(' + $env.imgUrl + 'home-bg-1.png);'">
      <div class="safe-area page-flex-lr-center">
        <div class="lf">
          <pageTitle cn="财商素养领域" en="PBL & Financial Literacy" type="2"></pageTitle>
          <div class="common-title-d3 mt-20">财商是每个人无法回避的生活功课。大赛以PBL的方式，让学生在真实的经济情境中学会尊重钱、善用钱、超越钱——最终拥有驾驭生活的能力与自由。</div>
          <div class="common-title-d4 mt-12">Financial intelligence is an unavoidable life lesson for everyone. The competition, adopting a problem-based learning (PBL) approach, enables students to learn to respect money, make good use of money, and transcend money in real economic scenarios - ultimately gaining the ability and freedom to master their lives.</div>
        </div>
        <div class="rt">
          <img :src="$env.imgUrl + 'pbl-s5.png'" alt="">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  }
}
</script>
<style scoped lang="less">
.section1 {
  padding: 60px 0 100px;
  margin-bottom: 10px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .imgs{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 20px;
    img{
      width: 24%;
      height: auto;
    }
  }
}

.section2{
  padding-top: 40px;
  padding-bottom: 60px;
  .lf{
    width: 30%;
    .common-title-d1{
      margin-top: 20px;
    }
  }
  .rt{
    flex: 1;
    margin-left: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    img{
      width: 24%;
      height: auto;
    }
  }
}
.section3{
  padding: 100px 0;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .imgs{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-top: 20px;
    img{
      width: 15%;
      height: auto;
    }
  }
  .vertical-title{
    color: #fff;
    font-size: 16px;
    font-family: systm;
    display: flex;
    line-height: 18px;
    margin-right: 10px;
    margin-top: 20px;
    div{
      width: 18px;
      margin-right: 6px;
    }
  }
}
.mt-20{
  margin-top: 20px;
}
.section4{
  padding: 40px 0 30px;
  .lf{
    width: 30%;
  }
  .rt{
    padding-left: 30px;
    flex: 1;
    img{
      width: 100%;
      height: auto;
    }
  }
}
.section5{
  padding: 100px 0 60px;
  background-repeat: no-repeat;
  background-size: 100% auto;
  .lf{
    width: 30%;
  }
  .rt{
    padding-left: 30px;
    flex: 1;
    img{
      width: 100%;
      height: auto;
    }
  }
}
</style>
